// src/config/site.js
export const SITE_URL = "https://alphaweb-93f02.web.app"; 
// 👉 quando colleghi il tuo dominio definitivo, cambia SOLO questa riga.

export const BRAND = {
  name: "AlphaFrame Analytics",
  logo: "/logo-512.png", // metti il path reale del tuo logo 256/512
};
